var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16,
    fill: "#2B2D33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.01h-2c-.97 0-1.61.49-1.88 1.33H16V3h-2v2.01h-2c-.97 0-1.61.49-1.88 1.33H10V3H8v2H4c-.58 0-1 .41-1 1v14c0 .59.41 1 1 1h16c.59 0 1-.41 1-1V6c0-.59-.41-.99-1-.99zM19 19H5v-6h14v6zm0-8H5V7h3v2h2v-.99c0-.55.35-1 1-1h3V9h2v-.99c0-.55.35-1 1-1h2V11z",
    fill: "#2B2D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.61a1.6 1.6 0 001.61-1.6c0-.89-.72-1.61-1.61-1.61a1.605 1.605 0 000 3.21z",
    fill: "#2B2D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlog);
export default __webpack_public_path__ + "static/media/CalendarBlog.16069d23abfe42678a664d8932a2fca6.svg";
export { ForwardRef as ReactComponent };